/* 赠好友 */
export default [
  {
    path: 'gift/detail',
    name: 'giftDetails',
    meta: {
      title: '赠好友',
    },
    component: () => import('@/views/gift/detail.vue')
  },
  {
    path: 'gift/receive',
    name: 'giftReceives',
    meta: {
      title: '赠好友',
    },
    component: () => import('@/views/gift/receive.vue')
  },
  {
    path: 'gift/shareIndex',
    name: 'shareIndex',
    meta: {
      title: '好友下单有礼',
    },
    component: () => import('@/views/gift/shareIndex.vue')
  },
  {
    path: 'gift/shareGoods',
    name: 'shareGoods',
    meta: {
      title: '好友下单有礼',
    },
    component: () => import('@/views/gift/shareGoods.vue')
  },
  {
    path: 'gift/info',
    name: 'giftInfo',
    meta: {
      title: '免费赠好友',
    },
    component: () => import('@/views/gift/info.vue')
  },
]